import React, { useState } from "react";
import catAssistantIcon from "../assets/cat_no_background.png";

const SAMPLE_PROMPTS = [
  "How much have I spent in Turris?",
  "When did I buy a table?",
  "What did I spend on groceries this month?"
];

function CatAssistantComponent() {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      sender: "assistant",
      text: "Hi! I can help you ask for expense sums, dates, and shop searches once the database query layer is connected."
    }
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const trimmed = input.trim();
    if (!trimmed) return;

    const lower = trimmed.toLowerCase();

    let response = "I’m ready to turn this into a MongoDB query as soon as the backend is connected.";

    if (lower.includes("turris")) {
      response = "I would sum all expenses with location matching Turris and return the total for that shop.";
    } else if (lower.includes("table")) {
      response = "I would search your expense names and notes for ‘table’ and sort the matching entries by date.";
    } else if (lower.includes("grocer") || lower.includes("grocery")) {
      response = "I would filter by the grocery category and show the total for the selected month or date range.";
    } else if (lower.includes("how much") || lower.includes("total") || lower.includes("spent")) {
      response = "I would calculate the total from the matching expenses in your database.";
    } else if (lower.includes("when") || lower.includes("buy") || lower.includes("date")) {
      response = "I would look for the matching item and return the oldest and most recent purchase dates.";
    }

    setMessages((prev) => [
      ...prev,
      { sender: "user", text: trimmed },
      { sender: "assistant", text: response }
    ]);
    setInput("");
  };

  return (
    <div className="cat-assistant-wrapper">
      <button
        type="button"
        className="cat-assistant-button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Open Spendcat assistant"
      >
        <img src={catAssistantIcon} alt="Spendcat assistant" />
        <span className="assistant-badge">?</span>
      </button>

      {isOpen && (
        <div className="cat-assistant-panel" role="dialog" aria-label="Spendcat assistant chat">
          <div className="cat-assistant-header">
            <div>
              <strong>Spendcat Assistant</strong>
            </div>
            <button type="button" className="close-panel" onClick={() => setIsOpen(false)} aria-label="Close assistant">
              ×
            </button>
          </div>

          <div className="cat-assistant-messages">
            {messages.map((message, index) => (
              <div
                key={`${message.sender}-${index}`}
                className={`cat-assistant-message ${message.sender === "user" ? "user" : "assistant"}`}
              >
                {message.text}
              </div>
            ))}
          </div>

          <div className="cat-assistant-suggestions">
            {SAMPLE_PROMPTS.map((sample) => (
              <button
                key={sample}
                type="button"
                className="cat-assistant-suggestion"
                onClick={() => setInput(sample)}
              >
                {sample}
              </button>
            ))}
          </div>

          <form onSubmit={handleSubmit} className="cat-assistant-form">
            <input
              type="text"
              value={input}
              onChange={(event) => setInput(event.target.value)}
              placeholder="Ask about an expense..."
              aria-label="Ask the assistant"
            />
            <button type="submit">Send</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default CatAssistantComponent;
